import React from 'react';
import cx from 'classnames';
import '../../../../ui/accordions/Accordion/index.js';
import '../../../../ui/accordions/AccordionSelect/index.js';
import '../../../../ui/badges/Badge/index.js';
import '../../../../ui/badges/BadgeIcon/index.js';
import '../../../../ui/badges/Checked/index.js';
import '../../../../ui/badges/Panel/index.js';
import '../../../../ui/badges/Status/index.js';
import '../../../../ui/badges/Tag/index.js';
import '../../../../ui/buttons/BabyButton/Base.js';
import '../../../../ui/buttons/BabyButton/variants/Chat/index.js';
import '../../../../ui/buttons/BabyButton/variants/Menu/index.js';
import '../../../../ui/buttons/BabyButton/variants/User/index.js';
import '../../../../ui/buttons/BabyButton/variants/Vip/index.js';
import '../../../../ui/buttons/BabyButton/variants/Wallet/index.js';
import '../../../../ui/buttons/Button/index.js';
import { CloseButton2 } from '../../../../ui/buttons/CloseButton/index.js';
import '../../../../ui/buttons/DirectionButton/index.js';
import '../../../../ui/buttons/GradientButton/index.js';
import '../../../../ui/buttons/GradientButtonV2/index.js';
import '../../../../ui/buttons/TabButton/index.js';
import '../../../../ui/buttons/TabButtonV2/index.js';
import '../../../../ui/buttons/TimerButton/index.js';
import '../../../../ui/buttons/TimerButtonV2/index.js';
import '../../../../ui/buttons/TimerButtonV3/index.js';
import '../../../../ui/loaders/Loader/index.js';
import '../../../../ui/loaders/ScreenLoader/index.js';
import '../../../../ui/modals/Modal/MobileWrapperV2/index.js';
import '../../../../ui/modals/Modal/Modal.js';
import '../../../../ui/modals/Modal/ModalContentWrapper/index.js';
import '../../../../ui/popups/Popper/index.js';
import '../../../../ui/popups/Popup/BasePopup/index.js';
import '../../../../ui/popups/Popup/Thumb/index.js';
import '../../../../ui/popups/Popup/ThumbV2/index.js';
import '../../../../ui/popups/Popup/InfoTooltip/index.js';
import '../../../../ui/sliders/EmblaCarousel/index.js';
import '../../../../ui/tables/Table/index.js';
import '../../../../ui/tables/Table/TableTd/index.js';
import '../../../../ui/tabs/Tabs/index.js';
import '../../../../ui/tabs/TabsV2/index.js';
import '../../../../ui/texts/CryptoValue/index.js';
import '../../../../ui/texts/AmountValue/index.js';
import '../../../../ui/texts/TitleWithCurrency/index.js';
import '../../../../ui/texts/Text/index.js';
import '../../../../ui/texts/TextNavigation/index.js';
import '../../../../ui/texts/MinValue/index.js';
import '../../../../ui/socials/SocialsList/index.js';
import { PrevButton } from '../../../../ui/buttons/PrevButton/index.js';
import styles from './index.module.scss.js';

const RDHeader = ({
  title,
  onPrev,
  onClose,
  className,
  style,
  children,
  ...props
}) => /* @__PURE__ */ React.createElement(
  "div",
  {
    className: cx(styles.box, className),
    style,
    "data-animation": "reward-modal-header",
    ...props
  },
  children || /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(
    "div",
    {
      className: cx(styles.title),
      style: {
        "--align": onPrev ? "flex-start" : "center"
      }
    },
    onPrev && /* @__PURE__ */ React.createElement(PrevButton, { onClick: onPrev }),
    title
  ), onClose && /* @__PURE__ */ React.createElement(CloseButton2, { onClick: onClose }))
);
RDHeader.displayName = "RewardsDropdown.RDHeader";

export { RDHeader };
//# sourceMappingURL=index.js.map
